import { SelectTheme } from '../../base/tokens';

export const select: SelectTheme = {
  container: {
    base: 'relative w-full',
    active: 'relative w-full'
  },
  label: {
    wrapper: 'block text-sm font-medium text-cyan-100/90',
    text: 'block text-sm text-cyan-100/70'
  },
  field: {
    wrapper: 'mt-1 relative',
    select: {
      base: 'relative w-full cursor-pointer rounded-lg bg-gray-900/50 py-2 pl-4 pr-10 text-left border border-cyan-500/20 focus:outline-none focus:ring-2 focus:ring-cyan-400/30 transition-colors duration-200 text-sm',
      placeholder: 'text-cyan-100/30 text-sm',
      active: 'border-orange-400/50 ring-2 ring-orange-400/30',
      disabled: 'opacity-50 cursor-not-allowed',
      text: 'text-cyan-100 text-sm'
    },
    icon: {
      wrapper: 'absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none',
      active: 'text-cyan-400',
      svg: 'h-4 w-4 text-cyan-400/50'
    }
  },
  options: {
    wrapper: `
      absolute z-[999] mt-1 w-full overflow-visible rounded-lg 
      bg-gray-900/95 py-1 shadow-lg ring-1 ring-cyan-500/20 
      backdrop-blur-sm max-h-[400px]
    `,
    list: 'py-1 text-sm focus:outline-none',
    item: {
      base: 'relative cursor-pointer select-none py-1.5 pl-4 pr-9 transition-colors duration-200',
      active: 'bg-cyan-500/10',
      selected: 'bg-cyan-500/20',
      content: 'flex items-center',
      text: 'block truncate text-sm',
      textSelected: 'font-medium text-cyan-300 text-sm',
      textUnselected: 'text-cyan-100/70 text-sm'
    },
    checkbox: {
      base: 'absolute right-2 flex h-4 w-4 items-center justify-center',
      selected: 'text-cyan-400',
      unselected: 'text-cyan-100/20',
      icon: 'h-4 w-4'
    }
  }
};